"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var InputComponent = /** @class */ (function (_super) {
    __extends(InputComponent, _super);
    function InputComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { editing: false, text: "" };
        _this.getFormProps = function () { return ({
            onBlur: function () { return _this.setState({ editing: false }); },
            onChange: function (_a) {
                var value = _a.target.value;
                return _this.setState({ text: value });
            },
            ref: function (form) { return _this.form = form; },
            value: _this.state.text,
        }); };
        return _this;
    }
    InputComponent.prototype.componentDidUpdate = function (_, _a) {
        var editing = _a.editing;
        var onEdit = this.props.onEdit;
        if (!editing && this.state.editing) {
            this.form.focus(); // Do this after rendering.
            // Set an initial value and move a cursor to end.
            var text = this.props.text;
            this.form.value = "";
            this.form.value = text;
            this.setState({ text: text });
        }
        else if (editing && !this.state.editing && onEdit) {
            onEdit(this.state.text);
        }
    };
    return InputComponent;
}(React.Component));
exports.default = InputComponent;



//////////////////
// WEBPACK FOOTER
// ./src/component/InputComponent.tsx
// module id = 224
// module chunks = 0